/**
 * Global Design Tokens - Cyber-Minimal Theme
 * 
 * To swap the theme, only modify these values.
 * Colors: Black (Background), Cyber-Green (Primary), White (Text/Accents)
 */

export const tokens = {
  colors: {
    background: '#0a0a0b',
    surface: '#141417',
    surfaceLighter: '#1c1c21',
    primary: '#00ff9d',
    primaryGlow: 'rgba(0, 255, 157, 0.3)',
    secondary: '#ffffff',
    text: '#ffffff',
    textDim: '#a0a0a0',
    border: '#2a2a32',
    accent: '#00ff9d',
    error: '#ff4b4b',
    glow: 'rgba(0, 255, 157, 0.5)',
    keycapBase: '#1a1a1e',
    keycapTop: '#242429',
    legendActive: '#000000',
    legendIdle: '#e0e0e0',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '64px',
  },
  typography: {
    fontFamily: '"Space Grotesk", "IBM Plex Sans", "Segoe UI", system-ui, sans-serif',
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '20px',
      xl: '24px',
      h1: '32px',
    },
    fontWeight: {
      light: '300',
      regular: '400',
      bold: '700',
    },
  },
  motion: {
    curve: 'cubic-bezier(0.4, 0, 0.2, 1)',
    speed: {
      fast: '150ms',
      normal: '300ms',
      slow: '500ms',
    },
  },
  radius: {
    none: '0px',
    sm: '2px',
    md: '4px',
    lg: '12px',
  },
  borders: {
    thin: '1px solid var(--color-border)',
    glow: '1px solid var(--color-primary)',
  },
  shadows: {
    glow: '0 0 10px var(--color-glow)',
    glowLarge: '0 0 20px var(--color-glow)',
  }
};

/**
 * Inject tokens into CSS custom properties
 */
export function injectTokens() {
  const root = document.documentElement;
  
  // Colors
  Object.entries(tokens.colors).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });
  
  // Spacing
  Object.entries(tokens.spacing).forEach(([key, value]) => {
    root.style.setProperty(`--spacing-${key}`, value);
  });
  
  // Typography
  root.style.setProperty('--font-family', tokens.typography.fontFamily);
  Object.entries(tokens.typography.fontSize).forEach(([key, value]) => {
    root.style.setProperty(`--font-size-${key}`, value);
  });
  
  // Motion
  root.style.setProperty('--motion-curve', tokens.motion.curve);
  Object.entries(tokens.motion.speed).forEach(([key, value]) => {
    root.style.setProperty(`--motion-speed-${key}`, value);
  });
  
  // Radii
  Object.entries(tokens.radius).forEach(([key, value]) => {
    root.style.setProperty(`--radius-${key}`, value);
  });

  // Shadows
  Object.entries(tokens.shadows).forEach(([key, value]) => {
    const cssKey = key === 'glowLarge' ? 'glow-large' : key;
    root.style.setProperty(`--shadow-${cssKey}`, value);
  });
}
